export default __webpack_public_path__ + "static/media/Button-Videos.8aaaf374.svg";